module.exports = __webpack_public_path__ + "img/new_logo.2b7b297c.png";